import { getTargetURLByENV } from "@/utils/detect";

export const domain = "//api.bilibili.com";
export const pagePrefix = "//activity.bilibili.com";
export const apiPrefix = `${domain}/x/fission/boxes`;
export const sharePrefix = `${domain}/x/fission`;
export const batteryApiPrefix = `${domain}/x/fission`;
export const shareAPIPrefix = `${domain}/x/fission/share`;
export const broadCaseApiPrefix = `${domain}/x/fission/notice`;
export const getUserInfoUrl = `${domain}/x/web-interface/nav`;

export const ACTIVITY_UID = "boxes-01";
export const BATTERY_ACTIVITY_UID = "charge-storage";

export const ROUTER_NAME = {
  HOME: "/",
  PCLANDING: "/pcLanding",
  MOBILE: "/mobile",
  OLDAPP: "/oldApp",
  SELECT: "/select",
  INVITE: "/invite",
  END: "/end",
  ADDRESS: "/address",
  DETAIL: "/detail",
  BATTERY: "/battery"
};

export const userDesc = {
  s11: "biubiubiu，S11额外任务能量已到账",
  bili: "biubiubiu，创世能量已到账",
  newuser: "Boom！新兵助力，给你超多能量！",
  inactive: "Duang！老将回归，甜蜜暴击！",
  active: ["吧唧，爱的能量已注入！", "哔哩常客光临，小幅充能完毕！", "我已给你充入一丢丢能量哟！"],
  task_browse: "浏览会员购任务充能",
  task_buy: "购买商品任务充能"
};

// 打点wiki: https://info.bilibili.co/pages/viewpage.action?pageId=122230281
// 接口文档：https://info.bilibili.co/pages/viewpage.action?pageId=116239284#id-%E5%85%85%E8%83%BD%E7%AB%99%E6%8E%A5%E5%8F%A3%E6%96%87%E6%A1%A3-%E6%9E%81%E9%AA%8C%E5%88%9D%E5%A7%8B%E5%8C%96%EF%BC%88%E5%B1%B1%E4%BA%BA%EF%BC%89
export const salt = "MZh2aLcH@";

export const PAGE_IDS = {
  INVITE: "/redpack/activity-ym79HyMbEI.html",
  HOME: "/activity-LdHkz8NnqJ.html",
  POPUP: "/activity-BciuE9gRGK.html",
  REDPACK: "/redpack/activity-8SX5lYqUj.html",
  BATTERY_INVITE: "/redpack/activity-g3g7NQEFZ8.html"
};

// 基于环境拼接的页面地址
export const PAGE_URLS = {
  INVITE: getTargetURLByENV(PAGE_IDS.INVITE),
  HOME: getTargetURLByENV(PAGE_IDS.HOME),
  POPUP: getTargetURLByENV(PAGE_IDS.POPUP),
  REDPACK: getTargetURLByENV(PAGE_IDS.REDPACK),
  BATTERY_INVITE: getTargetURLByENV(PAGE_IDS.BATTERY_INVITE)
};

// 拉新红包提现页面地址
export const uatRedbagPageUrl = "https://pay.bilibili.com/pay-v2/redbag/index?navhide=1&withdrawActivityId=3d69496b583b42ed&ts=1669688003&refer=dmbx";
export const redbagPageUrl = "https://pay.bilibili.com/pay-v2/redbag/index?navhide=1&withdrawActivityId=7695ba72f7d1ca25a51252e0b732ff8d&ts=1672502399&refer=dmbx";

export const makeSharePageUrl = (baseUrl: string, token: string, channel: string) =>
  `${baseUrl}?token=${token}&channel=${channel}&powerup_status=1`;
export enum PicShareChannel {
  WEIXIN_PIC = "WEIXIN_PIC",
  QQ_PIC = "QQ_PIC",
  SAVE_PIC = "SAVE_PIC"
}
export const picShareChannels = [
  {
    name: "微信",
    picture: "//activity.hdslb.com/blackboard/static/491d90335af7384363d82d8e3fbfcb30/IjoPONtD5m.png",
    share_channel: PicShareChannel.WEIXIN_PIC,
    source: 1
  },
  {
    name: "QQ",
    picture: "//activity.hdslb.com/blackboard/static/491d90335af7384363d82d8e3fbfcb30/hFMEoCQ7Fz.png",
    share_channel: PicShareChannel.QQ_PIC,
    source: 3
  },
  {
    name: "图片保存",
    picture: "//activity.hdslb.com/blackboard/static/0d82a81ec9aff95216c0273a83ab1ddb/gYrVkMLEnR.png",
    share_channel: PicShareChannel.SAVE_PIC,
    source: 7
  }
];

export const shareChannels = [
  {
    name: "微信",
    picture: "//activity.hdslb.com/blackboard/static/491d90335af7384363d82d8e3fbfcb30/IjoPONtD5m.png",
    share_channel: "WEIXIN",
    source: 1
  },
  {
    name: "QQ",
    picture: "//activity.hdslb.com/blackboard/static/491d90335af7384363d82d8e3fbfcb30/hFMEoCQ7Fz.png",
    share_channel: "QQ",
    source: 3
  },
  {
    name: "图片分享",
    picture: "//activity.hdslb.com/blackboard/static/0d82a81ec9aff95216c0273a83ab1ddb/fEgSXnpD7R.png",
    share_channel: "PIC",
    source: 7
  },
  {
    name: "复制链接",
    picture: "//activity.hdslb.com/blackboard/static/0d82a81ec9aff95216c0273a83ab1ddb/Isk20cF6Wd.png",
    share_channel: "COPY",
    source: 6
  }
];
export const commandChannel = [
  {
    name: "活动口令",
    picture: "//activity.hdslb.com/blackboard/static/0d82a81ec9aff95216c0273a83ab1ddb/gMuZdPHPfv.png",
    share_channel: "COMMAND",
    source: 6
  }
];
export const batteryShareChannels = [
  {
    name: "微信",
    picture: "//activity.hdslb.com/blackboard/static/491d90335af7384363d82d8e3fbfcb30/IjoPONtD5m.png",
    share_channel: "WEIXIN",
    source: 1
  },
  {
    name: "QQ",
    picture: "//activity.hdslb.com/blackboard/static/491d90335af7384363d82d8e3fbfcb30/hFMEoCQ7Fz.png",
    share_channel: "QQ",
    source: 3
  },
  {
    name: "QQ空间",
    picture: "//activity.hdslb.com/blackboard/static/491d90335af7384363d82d8e3fbfcb30/Do52oLonQ1.png",
    share_channel: "Q_ZONE",
    source: 4
  },
  {
    name: "微博",
    picture: "//activity.hdslb.com/blackboard/static/28f8ecbd17f5bcc51d9fa3fd5bac7950/dYw6ENTABh.png",
    share_channel: "SINA",
    source: 5
  }
];

export const shareConfig = {
  title: "恭喜你发现宝藏!",
  text: "上B站看游戏视频，开弹幕宝箱! 戳我直达 >>",
  imageUrl: "https://activity.hdslb.com/blackboard/static/0d82a81ec9aff95216c0273a83ab1ddb/DM9TtNzk5S.jpg"
};

export const batteryShareConfig = {
  title: "你的好友提醒你完成任务啦！",
  text: "上B站看视频，助力好友得能量",
  imageUrl: "https://activity.hdslb.com/blackboard/static/28f8ecbd17f5bcc51d9fa3fd5bac7950/W1kH16RtBj.jpg"
};
